import { HotelReservedCardContentPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-card/hotel-reserve-card-content/hotel-reserved-card-content.types";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { deepCompare } from "@website/utils/deep-compare";
import isEmpty from "lodash-es/isEmpty";
import { FC, memo } from "react";

const Component: FC<
  Pick<
    HotelReservedCardContentPropertiesType,
    "onClick" | "id" | "notifyData" | "roomCount"
  >
> = (properties) => {
  const { onClick, id, notifyData, roomCount } = properties;

  return (
    <div
      className={`flex flex-col items-center gap-4 p-4 lg:max-h-[64px] lg:flex-row lg:gap-6 ${
        isEmpty(notifyData) ? "justify-end" : "justify-between"
      }`}
    >
      {!isEmpty(notifyData) && (
        <Button
          StartIcon={
            notifyData?.isSubmitted ? (
              <MaterialIcon name="check" />
            ) : (
              <MaterialIcon name="notifications_active" variant="outlined" />
            )
          }
          className="order-3 w-full md:order-1 lg:w-[170px]"
          color={notifyData?.isSubmitted ? "neutral" : "secondary"}
          loading={notifyData?.isSubmitted && notifyData?.isLoading}
          onClick={() =>
            notifyData?.onclick(Number(id), notifyData?.isSubmitted)
          }
          size="small"
          variant="outline"
        >
          موجود شد خبرم کن
        </Button>
      )}
      <div className="order-2 flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-6">
        <div className="text-on-surface-high-emphasis text-caption">
          بررسی وضعیت موجودی اتاق از روی تقویم
        </div>
        <Button
          className="order-1 w-full md:order-3 lg:w-[118px]"
          color="secondary"
          onClick={() =>
            onClick
              ? onClick({
                  roomId: id,
                  tabSelected: "roomCalendar",
                  noRooms: roomCount
                })
              : undefined
          }
          size="small"
          variant="text"
        >
          تقویم موجودی
        </Button>
      </div>
      <Modal
        className="!z-20"
        mobileHeight="auto"
        open={Boolean(notifyData?.isOpenModal)}
      >
        <div className="flex h-full flex-col gap-6">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row gap-4">
              <MaterialIcon
                className="text-on-surface-medium-emphasis text-headline-5"
                name="notifications_active"
                variant="outlined"
              />
              <span className="text-headline-6">موجود شد خبرم کن</span>
            </div>
            <MaterialIcon
              className="cursor-pointer"
              name="close"
              onClick={notifyData?.onCloseModal}
            />
          </div>
          <div
            className={`${
              notifyData?.isLimited ? "flex-auto" : ""
            } text-body-2`}
          >
            {notifyData?.isLimited ? (
              <div>
                <div>تعداد درخواست‌های فعال شما به سقف مجاز رسیده است.</div>
                <div>
                  پس از مشخص شدن وضعیت یکی از آن‌ها، می‌توانید مجدداً درخواست
                  ثبت کنید.
                </div>
              </div>
            ) : (
              "در صورت موجود شدن این اتاق، از طریق پیامک به شما اطلاع خواهیم داد."
            )}
          </div>
          {!notifyData?.isLimited && (
            <div className="text-caption text-on-surface-medium-emphasis flex-auto">
              توجه: شما می‌توانید حداکثر برای ۱۵ درخواست اطلاع‌رسانی ثبت کنید.
            </div>
          )}
          <Button
            color="secondary"
            loading={notifyData?.isLoading}
            onClick={() =>
              notifyData?.onclick(Number(id), notifyData?.isSubmitted)
            }
            text={notifyData?.isLimited ? "متوجه شدم" : "خبرم کن"}
          />
        </div>
      </Modal>
    </div>
  );
};
export const HotelReserveCardFullCapacity = memo(Component, deepCompare);
